import createNetworkingClient from 'utils/networking-client';
import { StatusCodes } from 'http-status-codes';
import { FOLLOWING_STATUS } from '../../constants/follows/following-constants';
import { logError } from '../../utils/sentry';

/**
 *  Follows an athlete on strava.
 *
 * @param {Object} param
 * @param {string} param.followerId - id for the athlete who is requesting the follow
 * @param {string} param.followingId - id for the athlete to be followed
 * @returns {Promise<FOLLOWING_STATUS>} - enum value PENDING or FOLLOWING
 */
export const followAthlete = ({ followerId, followingId }) => {
  return new Promise((resolve) => {
    createNetworkingClient()
      .post(`/athletes/${followerId}/follows`, {
        follow: {
          follower_id: followerId,
          following_id: followingId
        }
      })
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          const { data } = response;
          if (data.approved) {
            resolve(FOLLOWING_STATUS.following);
          } else {
            resolve(FOLLOWING_STATUS.pending);
          }
        } else {
          resolve(FOLLOWING_STATUS.error);
          // TODO log sentry error
        }
      })
      .catch(() => {
        resolve(FOLLOWING_STATUS.error);
        // TODO log sentry error
      });
  });
};

export const unfollowAthlete = ({ followerId, followingId }) => {
  return new Promise((resolve) => {
    createNetworkingClient()
      .delete(
        `/athletes/${followerId}/follows/${followingId}`,
        {
          data: {
            follow: {
              follower_id: followerId,
              following_id: followingId
            }
          }
        },
        { headers: { Accept: 'text/javascript' } }
      )
      .then((response) => {
        if (response?.status === StatusCodes.NO_CONTENT) {
          resolve(true);
        } else {
          logError(response);
          resolve(false);
        }
      })
      .catch((e) => {
        logError(e);
        resolve(false);
      });
  });
};

export default { followAthlete, unfollowAthlete };
